/**
 * Updates the event buttons on the page based on the event data.
 * @param {AvailableEvents} availableEvents - Object with {events: EventiveEvent[] | []}.
 * @param {EventBucketConfig} eventBucketConfig - Array of event objects fetched from the API.
 */
export function updateEventButtons(availableEvents, eventBucketConfig) {
  if (!availableEvents || !availableEvents.events || availableEvents.events.length === 0) {
    console.warn('No available events found.');
    // Falls keine Events vorhanden sind, alle Buttons deaktivieren
    const eventButtons = document.querySelectorAll('[data-eventid]');
    eventButtons.forEach(button => {
      button.textContent = 'No Available';
      button.disabled = true;
      button.classList.add('disabled');
    });
    return;
  }

  /** @type {EventiveEvent[]} */
  const events = availableEvents.events;

  events.forEach((/** @type {EventiveEvent} */ event) => {
    const eventButtons = document.querySelectorAll(`[data-eventid="${event.id}"]`);

    if (eventButtons.length === 0) {
      return;
    }

    // Check whether the button should be hidden from event config.
    if (event?.hide_tickets_button) {
      eventButtons.forEach(button => button.disabled = true);
      return; // If all buttons are deactivated, switch to the next event
    }

    // Check if the event has expired (based on end_time)
    const endTime = new Date(event.end_time);
    const now = new Date();

    if (endTime < now) {
      eventButtons.forEach(button => {
        button.textContent = 'Already occurred';
        button.disabled = true;
        button.classList.add('disabled');
      });
      return;
    }

    // Check if tickets are available in the ticket_bucket
    const hasAvailableTickets = event.ticket_buckets.some(bucket => bucket.quantity_remaining > 0);

    eventButtons.forEach(button => {
      if (!hasAvailableTickets) {
        button.textContent = eventBucketConfig?.event_sold_out_button_label || 'Sold Out';
        button.disabled = true;
        button.classList.add('sold-out', 'disabled');
      } else {
        button.textContent = event?.tickets_button_label || eventBucketConfig?.order_tickets_button || 'Tickets';
        button.disabled = false;
        button.classList.remove('disabled', 'sold-out');
      }
    });
  });
}
